import { create } from "zustand";
import { confirmUserAttribute } from "aws-amplify/auth";
import { toast } from "sonner";
import { setStatusToUserUpdated, userUpdateEmailManually } from "./userState";

export type ConfirmNewEmailState = {
  error: Error | null;
};

export const confirmNewEmailState = create<ConfirmNewEmailState>(() => ({
  error: null,
}));

export const confirmNewEmailIsError = (error: Error) =>
  confirmNewEmailState.setState(() => ({
    error: error,
  }));

export const resetConfirmNewEmailState = () =>
  confirmNewEmailState.setState(() => confirmNewEmailState.getInitialState());

export type ConfirmNewEmailParams = {
  code: string;
  email: string;
};

export const confirmNewEmail = async ({
  code,
  email,
}: ConfirmNewEmailParams) => {
  try {
    await confirmUserAttribute({
      userAttributeKey: "email",
      confirmationCode: code,
    });

    toast.success(`Votre email a été mis à jour.`, {
      duration: 2000,
    });
    userUpdateEmailManually(email);
    setStatusToUserUpdated(true);
  } catch (error) {
    confirmNewEmailIsError(new Error(error as string));
  }
};
